export default __webpack_public_path__ + "static/media/news072601.ff9c0585.jpg";